/** @jsx jsx */

import { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { useDroppable } from '@dnd-kit/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';

const { lPink, lGrey0, lGrey1 } = colors;

const MatchDrop = props => {
  const { droppableId, isDropDisabled = false, style, children } = props;

  const context = useContext(interactionContext);
  const {
    dropZoneColor = lGrey1,
    panelWidth = 250,
    panelHeight = 250,
    panelBorderRadius = 5,
  } = context.props;

  const mediaType = children[0].props.child;

  const { isOver, setNodeRef } = useDroppable({
    id: props.id || droppableId,
  });

  const id = `match-drop-${props?.id}`;

  return (
    <div
      ref={setNodeRef}
      id={id}
      className={'droppable-container'}
      css={css`
            position: relative;
            width: ${panelWidth}px;
            height: ${panelHeight}px;
            margin: 10px;
            text-align: center;
            background: ${'transparent' || '#fff' || lGrey1};
            ${!isDropDisabled && `border: 2px dashed ${dropZoneColor};`}
            border-radius: ${panelBorderRadius}px;
            overflow: hidden;

            oultine: 10px solid red;
          `}
      style={style}
    >
      <div
        className="matchingPanel"
        css={css`
          position: absolute;
          display: flex;
          align-items: center;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          padding: ${mediaType === 0 ? '10px' : '0px'};

          .chameleon-image > div,
          .chameleon-image img {
            width: ${panelWidth}px !important;
            height: ${panelHeight}px !important;
          }
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default MatchDrop;
